<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <van-tabs
    v-model:active="active"
    color="#3F7C93"
    title-active-color="#3F7C93"
    title-inactive-color="#666666"
  >
    <van-tab title="我的论文"><MyPaper></MyPaper></van-tab>
    <van-tab title="论文评价"><Evaluate></Evaluate></van-tab>
  </van-tabs>
</template>
<script setup>
import MyPaper from "./components/paper/MyPaper.vue";
import Evaluate from "./components/paper/Evaluate.vue";
import {nextFn} from "@/utils/type.js";
//右箭头
const next = () => {
    nextFn()
}


</script>
